import { object, string, boolean } from "yup";

import "./schemas";

const nonWorkingPeriodSchema = object({
  name: string()
    .trim()
    .required()
    .matches(/^[a-zA-Z0-9 ]*$/, "Only alphanumerics with spaces are allowed."),
  registration: string()
    .trim()
    .required()
    .matches(/^[a-zA-Z0-9]*$/, "Only alphanumerics are allowed."),
  type: string()
    .trim()
    .required()
    .matches(/^[a-zA-Z0-9 ]*$/, "Only alphanumerics with spaces are allowed."),
  active: boolean(),
  trackingId: string().trim()
});

export default nonWorkingPeriodSchema;
